/* Copyright (C) 2019 SplendidCRM Software, Inc. All Rights Reserved. 
 * Any use of the contents of this file are subject to the SplendidCRM Professional Source Code License Agreement, or other written agreement between you and SplendidCRM ("License"). 
 * SplendidCRM owns all proprietary rights, including all copyrights, patents, trade secrets, and trademarks, in and to the contents of this file.  You will not link to or in any way 
 * combine the contents of this file or any derivatives with any Open Source Code in any manner that would require the contents of this file to be made available to any third party. 
 */

// 1. React and fabric. 
import * as React from 'react';
// 2. Store and Types. 
// 3. Scripts. 
// 4. Components and Views. 
import DashboardEditor from '../DashboardComponents/DashboardEditor';

interface IHomeDashboardEditViewProps
{
	ID: string;
}

class HomeDashboardEditView extends React.Component<IHomeDashboardEditViewProps>
{
	constructor(props: IHomeDashboardEditViewProps)
	{
		super(props);
	}

	componentDidCatch(error, info)
	{
		console.error((new Date()).toISOString() + ' ' + this.constructor.name + '.componentDidCatch', error, info);
	}

	public render()
	{
		return <DashboardEditor {...this.props} CATEGORY="Home" />;
	}
}

export default HomeDashboardEditView;
